import React from 'react';
import Receipt from './Receipt';

const getReceiptClassName = (index, columnsCount, receiptCount) => {
  const row = Math.floor(index / columnsCount);
  const col = index % columnsCount;
  const classes = [];

  if (col === columnsCount - 1) classes.push('last-in-row');
  if (row === Math.floor((receiptCount - 1) / columnsCount)) classes.push('last-row');

  return classes.join(' ');
};

const ReceiptSheet = ({
  scale,
  showCuttingLines,
  columnsCount,
  receiptCount,
  rowCount,
  sellerName,
  ico,
  dic,
  address,
  saleDate,
  rowsData,
  showBorders
}) => (
  <div className="page" style={{ transform: `scale(${scale})`, transformOrigin: 'top left' }}>
    <div className={`a4-page ${showCuttingLines ? 'with-cutting-lines' : ''}`}>
      <div className="receipt-container" style={{
        gridTemplateColumns: `repeat(${columnsCount}, 1fr)`,
        gridAutoRows: 'auto'
      }}>
        {Array.from({ length: receiptCount }, (_, index) => (
          <Receipt
            key={index}
            rowCount={rowCount}
            sellerName={sellerName}
            ico={ico}
            dic={dic}
            address={address}
            saleDate={saleDate}
            rowsData={rowsData}
            hasBorder={showBorders}
            className={getReceiptClassName(index, columnsCount, receiptCount)}
          />
        ))}
      </div>
    </div>
  </div>
);

export default ReceiptSheet;
